<template>
  <div id="notice" class="notice">
    <transition :name="transitionName" mode="out-in">
      <TransactionInfo
        :key="SELECTED_TRANSACTION.owner_id"
        :transaction="SELECTED_TRANSACTION"
      />
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import TransactionInfo from './TransactionInfo';

export default {
  name: 'Notice',
  components: {
    TransactionInfo,
  },
  data() {
    return {
      transitionName: 'slide-top',
    };
  },
  computed: {
    ...mapState(['SELECTED_TRANSACTION', 'TRANSACTIONS']),
  },
  watch: {
    SELECTED_TRANSACTION(next, prev) {
      if (!prev.owner_id) {
        this.transitionName = 'slide-top';
        return;
      }

      let prevIndex = this.TRANSACTIONS.result.findIndex(el => el.public_id === prev.public_id);
      let nextIndex = this.TRANSACTIONS.result.findIndex(el => el.public_id === next.public_id);

      this.transitionName = prevIndex < nextIndex ? 'slide-top' : 'slide-bottom';
    },
  },
};
</script>

<style lang="sass">
  .notice
    flex-basis: 45%
    max-width: 45%
    z-index: 9
    margin-top: 10px

    .card
      > div
        font-size: 1.12rem
        font-weight: 600
        position: relative
        display: none
        overflow: unset
        margin: -0.75pt
        padding: 3.48rem 1.84rem 3.48rem calc((4.24rem * 3) - 1.84rem)
        text-align: left
        color: #C7C7CB
        background-color: #27283C

        +respond-to("medium")
          display: block

        &::before
          +pseudo-block

          z-index: -1
          top: -0.75pt
          right: -0.75pt
          bottom: -0.75pt
          left: -0.75pt
          border-radius: 0.36rem
          background-color: transparent

        &::after
          +pseudo-block

          z-index: 0
          top: calc(50% - (calc(3.48rem * 2) / 2))
          left: 1.84rem
          width: calc(3.48rem * 2)
          height: calc(3.48rem * 2)
          border-radius: 50%
          background-color: #34A7F9
          background-image: url("~@/assets/img/symbol-telegram-white.svg")
          background-repeat: no-repeat
          background-position: center center
          background-size: 3.48rem

        &:hover
          cursor: pointer
          background-color: #2E3048

          &::before
            background-color: #34A7F9
</style>
